// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sbctnrmwmwnlameidnef.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNiY3Rucm13bXdubGFtZWlkbmVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxOTMyMTEsImV4cCI6MjA2MDc2OTIxMX0.Ma_xn6868GZOLL01HRgKwFotEjbl6_9xvx-6kWs3J9o";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});